import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  emits: ['language-changed'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const { locale } = useI18n()

function switchLanguage() {
  locale.value = locale.value === 'en' ? 'de' : 'en'
  localStorage.setItem('locale', locale.value)
  emit('language-changed')
}

const languageSwitchBtn = computed(() => (locale.value === 'de' ? 'DE' : 'EN'))

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    icon: "",
    class: "pa-0",
    onClick: switchLanguage
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(languageSwitchBtn.value), 1)
    ]),
    _: 1
  }))
}
}

})